import { CookieConsentType } from './CookieConsentType';

export type CookieConsentInfo = {
    heading: string;
    subheading: string;
    details: Array<{ heading: string; subheading: string }>;
    required?: boolean;
};

export type CookieConsent = {
    [key in CookieConsentType]?: CookieConsentInfo;
};

const cookieConsentData: CookieConsent = {
    required_storage: {
        heading: 'Nödvändiga kakor',
        subheading: 'Dessa kakor behövs för att SVT Play ska fungera korrekt.',
        required: true,
        details: [
            {
                heading: 'Inställningar',
                subheading:
                    'SVT sparar inställningar för ljudvolym, språkinställningar för uppspelning och om du vill spela upp nästa avsnitt automatiskt.',
            },
            {
                heading: 'Barnlås',
                subheading: 'SVT sparar den kod du ställt in för att göra SVT Play extra säkert för barn.',
            },
            {
                heading: 'Favoriter',
                subheading: 'SVT sparar titlar som du själv har favoritmärkt.',
            },
            {
                heading: 'Medgivande för kakor',
                subheading: 'SVT sparar dina aktuella inställningar för kakor.',
            },
        ],
    },
    functionality_storage: {
        heading: 'Förbättrad upplevelse',
        subheading:
            'Dessa kakor används för att anpassa innehåll och funktioner utifrån hur du använder SVT Play.',
        details: [
            {
                heading: 'Fortsätt titta',
                subheading:
                    'SVT sparar din tittningshistorik för att du ska kunna fortsätta titta där du slutade.',
            },
            {
                heading: 'Tips för dig',
                subheading:
                    'SVT använder din tittningshistorik för att kunna ge dig mer relevanta tips på program.',
            },
            {
                heading: 'Tidigare sökningar',
                subheading:
                    'SVT sparar din sökhistorik för att du lätt ska kunna se dina tidigare sökningar.',
            },
        ],
    },
    statistics_storage: {
        heading: 'Prestanda',
        subheading:
            'Dessa kakor används för att utveckla och förbättra SVT Play genom anonymiserad statistik och undersökningar.',
        details: [
            {
                heading: 'Statistik',
                subheading:
                    'SVT analyserar beteenden för att förbättra tjänsten och våra program. All information som samlas in är anonym.',
            },
            {
                heading: 'Tester',
                subheading: 'SVT testar regelbundet nya funktioner och förbättringar.',
            },
            {
                heading: 'Enkäter',
                subheading: 'SVT gör undersökningar i SVT Play.',
            },
        ],
    },
    ad_storage: {
        heading: 'Marknadsföring',
        subheading: 'Dessa kakor används för att på andra webbplatser tipsa dig om våra program.',
        details: [
            {
                heading: 'Kampanjer',
                subheading:
                    'SVT analyserar tittning i SVT Play för att på andra webbplatser kunna tipsa dig om våra program.',
            },
        ],
    },
};

export default cookieConsentData;
